import { gql } from '@apollo/client'

export default gql(`
    query($project: String){
        listAuthLogUsers(project: $project){
          user
        }
    }`
)
